import type { TableRowColorsType } from '@/common/types';

import { rowBackgroundColorClassMap } from '../../constants';

interface TeamsTableLegendProps {
  className?: string;
  items: { color: TableRowColorsType; label: string }[];
}

export default function TeamsTableLegend({ className = '', items }: TeamsTableLegendProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className={`flex flex-col gap-2.5 ${className}`}>
      {items.map(({ color, label }) => (
        <div key={`${color}-${label}`} className="flex items-center gap-2">
          <div
            className={`shrink-0 size-[12px] rounded-full ${rowBackgroundColorClassMap[color]}`}
          />
          <span className="truncate font-robotoMedium font-medium text-[10px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
}
